module.exports = __webpack_public_path__ + "img/TNT_Vacature_0-1.6d485802.webp";